export const PENDING = 'PENDIENTE';
